import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import URL from 'drip/utils/url';
export function redirectUrl() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'redirectUrl';
  var redirectUrl = URL.getQuery(key) || URL.getHashQuery(key);
  if (redirectUrl) {
    var url = decodeURIComponent(redirectUrl);
    location.replace(url);
    return true;
  }
  return false;
}